import { render, staticRenderFns } from "./PDPModalAppleCareInfo.vue?vue&type=template&id=dc679428&scoped=true"
import script from "./PDPModalAppleCareInfo.vue?vue&type=script&lang=js"
export * from "./PDPModalAppleCareInfo.vue?vue&type=script&lang=js"
import style0 from "./PDPModalAppleCareInfo.vue?vue&type=style&index=0&id=dc679428&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc679428",
  null
  
)

export default component.exports